module.exports = __webpack_public_path__ + "static/img/map.dfdd60ea.png";